<template>
  <div v-if="shouldShow" class="chat-notification">
    <span class="notification-text">{{ currentMessage }}</span>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      notifications: new Set(),
      currentMessage: '',
      lastMessage: '',
    };
  },
  computed: {
    shouldShow() {
      return this.isActive && this.currentMessage !== '';
    },
  },
  watch: {
    message(newMessage) {
      if (newMessage && (!this.notifications.has(newMessage) || newMessage === this.lastMessage)) {
        this.notifications.add(newMessage);
        this.currentMessage = newMessage;
        this.lastMessage = newMessage;
      }
    },
    isActive(newActive) {
      if (!newActive) {
        this.currentMessage = this.lastMessage; // Mantén el último mensaje visible
      }
    },
  },
  mounted() {
    if (this.message && this.isActive) {
      this.notifications.add(this.message);
      this.currentMessage = this.message;
      this.lastMessage = this.message;
    }
  },
};
</script>

<style scoped>
.chat-notification {
  display: flex;
  align-items: center;
  z-index: 202;
  max-width: 280px;
}

.notification-text {
  font-size: 0.8rem;
  font-weight: 800;
  color: white;
  background-color: #F36622;
  padding: 0.8rem 1rem;
  border-radius: 1rem 1rem 0rem 1rem;
}
</style>
